// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  overflow-x: hidden;
  min-height: 92vh;
}
@media (max-width: 400px) {
  main {
    min-height: 74vh;
  }
}
main .mainPage {
  margin: auto;
  text-align: center;
}

/* Light mode */
@media (prefers-color-scheme: light) {
  body {
    background-color: #fff;
    color: #1d1d1d;
  }
}
.home__page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.home__page h1 {
  text-transform: uppercase;
  text-align: center;
}
.home__page .login__field {
  position: relative;
}
.home__page .login__field .login_icon {
  color: #bf1a1a;
  position: absolute;
  top: 12%;
}
.home__page .login__field input {
  border: none;
  border-bottom: 2px solid #1d1d1d;
  background: none;
  padding: 10px;
  padding-left: 24px;
  font-weight: 700;
  width: 75%;
  transition: 0.2s;
  margin-bottom: 3%;
}
.home__page .login__field input:active, .home__page .login__field input:focus, .home__page .login__field input:hover {
  outline: none;
  border-bottom-color: #bf1a1a;
}
.home__page .login_button {
  background: #fff;
  font-size: 14px;
  margin-top: 30px;
  padding: 16px 20px;
  border-radius: 26px;
  border: 1px solid #bf1a1a;
  text-transform: uppercase;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 10vw;
  color: #1d1d1d;
  box-shadow: 0px 2px 2px #bf1a1a;
  cursor: pointer;
  transition: 0.2s;
}
.home__page .login_button:active, .home__page .login_button:focus, .home__page .login_button:hover {
  border-color: #bf1a1a;
  outline: none;
}
.home__page small {
  margin: 10px auto;
  cursor: pointer;
}
.home__page small:hover, .home__page small:active {
  color: #bf1a1a;
}
@media (max-width: 690px) {
  .home__page .login_button {
    width: 50vw;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .home__page .login_button {
    width: 25vw;
  }
}

.password__set {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.password__set input {
  border: none;
  border-bottom: 2px solid #1d1d1d;
  background: none;
  padding: 10px;
  padding-left: 24px;
  font-weight: 700;
  transition: 0.2s;
  margin-bottom: 3%;
}
.password__set input:active, .password__set input:focus, .password__set input:hover {
  outline: none;
  border-bottom-color: #bf1a1a;
}
.password__set .login_button {
  background: #fff;
  font-size: 14px;
  margin-top: 30px;
  padding: 16px 20px;
  border-radius: 26px;
  border: 1px solid #bf1a1a;
  text-transform: uppercase;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 10vw;
  color: #1d1d1d;
  box-shadow: 0px 2px 2px #bf1a1a;
  cursor: pointer;
  transition: 0.2s;
}
.password__set .login_button:active, .password__set .login_button:focus, .password__set .login_button:hover {
  border-color: #bf1a1a;
  outline: none;
}
@media (max-width: 690px) {
  .password__set .login_button {
    width: 50vw;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .password__set .login_button {
    width: 25vw;
  }
}

#pass__modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
#pass__modal .row__modal {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 1% auto;
}
#pass__modal .row__modal .send__btn,
#pass__modal .row__modal .cancel__btn {
  border-radius: 0.5rem;
  text-transform: uppercase;
  font-weight: 600;
  padding: 1% 2%;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
#pass__modal .row__modal .send__btn:hover,
#pass__modal .row__modal .cancel__btn:hover {
  box-shadow: none;
}
#pass__modal .row__modal .cancel__btn {
  color: #bf1a1a;
  border: 2px solid #bf1a1a;
  background-color: #fff;
}
#pass__modal .row__modal .send__btn {
  color: #fff;
  background-color: #00a74f;
  border: 2px solid #00a74f;
}
@media (max-width: 690px) {
  #pass__modal .row__modal {
    margin: 2% auto;
  }
}
#pass__modal .form__field {
  margin-bottom: 8px;
}
#pass__modal .form__field input,
#pass__modal .form__field select {
  background-color: #fff;
  border: 1px solid #1d1d1d;
  color: #1d1d1d;
  width: 100%;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,8JAAA;AADJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAII;EAPJ;IAQQ,gBAAA;EADN;AACF;AAGI;EACI,YAAA;EACA,kBAAA;AADR;;AAKA,eAAA;AACA;EACI;IACI,sBAAA;IACA,cC5BE;ED0BR;AACF;AAKA;ECAI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ADFJ;AACI;EACI,yBAAA;EACA,kBAAA;AACR;AACI;EACI,kBAAA;AACR;AAAQ;EACI,cC1CJ;ED2CI,kBAAA;EACA,QAAA;AAEZ;AAAQ;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AAEZ;AADY;EAGI,aAAA;EACA,4BC5DR;AD6DR;AAGI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,cC7EE;ED8EF,+BAAA;EACA,eAAA;EACA,gBAAA;AADR;AAEQ;EAGI,qBCrFJ;EDsFI,aAAA;AAFZ;AAKI;EACI,iBAAA;EACA,eAAA;AAHR;AAIQ;EAEI,cC9FJ;AD2FR;AAMI;EACI;IACI,WAAA;EAJV;AACF;AAMI;EACI;IACI,WAAA;EAJV;AACF;;AAQA;EC5EI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ADwEJ;AAGI;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAEQ;EAGI,aAAA;EACA,4BC5HJ;AD0HR;AAKI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cC1IE;ED2IF,+BAAA;EACA,eAAA;EACA,gBAAA;AAHR;AAIQ;EAGI,qBClJJ;EDmJI,aAAA;AAJZ;AAMQ;EAtBJ;IAuBQ,WAAA;EAHV;AACF;AAIQ;EAzBJ;IA0BQ,WAAA;EADV;AACF;;AAKA;EC7HI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AD4HJ;AAAI;EACI,WAAA;ECpGJ,aAAA;EACA,mBAAA;EACA,6BAAA;EDoGI,eAAA;AAIR;AAHQ;;EAEI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mDAAA;AAKZ;AAJY;;EACI,gBAAA;AAOhB;AAJQ;EACI,cChLJ;EDiLI,yBAAA;EACA,sBAAA;AAMZ;AAJQ;EACI,WAAA;EACA,yBCnLF;EDoLE,yBAAA;AAMZ;AAJQ;EAzBJ;IA0BQ,eAAA;EAOV;AACF;AAJI;EACI,kBAAA;AAMR;AALQ;;EAEI,sBAAA;EACA,yBAAA;EACA,cCnMF;EDoME,WAAA;EACA,YAAA;AAOZ","sourcesContent":["@import \"./components/styles/variables.scss\";\n\n* {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n        \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n        \"Helvetica Neue\", sans-serif;\n}\n\nmain {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    overflow-x: hidden;\n    min-height: 92vh;\n    @media(max-width: 400px){\n        min-height: 74vh;\n    }\n\n    .mainPage {\n        margin: auto;\n        text-align: center;\n    }\n}\n\n/* Light mode */\n@media (prefers-color-scheme: light) {\n    body {\n        background-color: #fff;\n        color: $rtBlack;\n    }\n}\n\n.home__page {\n    @include columnStartCenter;\n    h1 {\n        text-transform: uppercase;\n        text-align: center;\n    }\n    .login__field {\n        position: relative;\n        .login_icon {\n            color: $rtRed;\n            position: absolute;\n            top: 12%;\n        }\n        input {\n            border: none;\n            border-bottom: 2px solid $rtBlack;\n            background: none;\n            padding: 10px;\n            padding-left: 24px;\n            font-weight: 700;\n            width: 75%;\n            transition: 0.2s;\n            margin-bottom: 3%;\n            &:active,\n            &:focus,\n            &:hover {\n                outline: none;\n                border-bottom-color: $rtRed;\n            }\n        }\n    }\n    .login_button {\n        background: #fff;\n        font-size: 14px;\n        margin-top: 30px;\n        padding: 16px 20px;\n        border-radius: 26px;\n        border: 1px solid $rtRed;\n        text-transform: uppercase;\n        font-weight: 700;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        max-width: 270px;\n        width: 10vw;\n        color: $rtBlack;\n        box-shadow: 0px 2px 2px $rtRed;\n        cursor: pointer;\n        transition: 0.2s;\n        &:active,\n        &:focus,\n        &:hover {\n            border-color: $rtRed;\n            outline: none;\n        }\n    }\n    small {\n        margin: 10px auto;\n        cursor: pointer;\n        &:hover,\n        &:active {\n            color: $rtRed;\n        }\n    }\n    @media (max-width: $mobile) {\n        .login_button {\n            width: 50vw;\n        }\n    }\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n        .login_button {\n            width: 25vw;\n        }\n    }\n}\n\n.password__set {\n    @include columnStartCenter;\n    input {\n        border: none;\n        border-bottom: 2px solid $rtBlack;\n        background: none;\n        padding: 10px;\n        padding-left: 24px;\n        font-weight: 700;\n        transition: 0.2s;\n        margin-bottom: 3%;\n        &:active,\n        &:focus,\n        &:hover {\n            outline: none;\n            border-bottom-color: $rtRed;\n        }\n    }\n    .login_button {\n        background: #fff;\n        font-size: 14px;\n        margin-top: 30px;\n        padding: 16px 20px;\n        border-radius: 26px;\n        border: 1px solid $rtRed;\n        text-transform: uppercase;\n        font-weight: 700;\n        display: flex;\n        align-items: center;\n        width: 10vw;\n        color: $rtBlack;\n        box-shadow: 0px 2px 2px $rtRed;\n        cursor: pointer;\n        transition: 0.2s;\n        &:active,\n        &:focus,\n        &:hover {\n            border-color: $rtRed;\n            outline: none;\n        }\n        @media (max-width: $mobile) {\n            width: 50vw;\n        }\n        @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n            width: 25vw;\n        }\n    }\n}\n\n#pass__modal {\n    @include columnStartCenter;\n    .row__modal {\n        width: 100%;\n        @include rowEven;\n        margin: 1% auto;\n        .send__btn,\n        .cancel__btn {\n            border-radius: 0.5rem;\n            text-transform: uppercase;\n            font-weight: 600;\n            padding: 1% 2%;\n            box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n            &:hover {\n                box-shadow: none;\n            }\n        }\n        .cancel__btn {\n            color: $rtRed;\n            border: 2px solid $rtRed;\n            background-color: #fff;\n        }\n        .send__btn {\n            color: #fff;\n            background-color: $success;\n            border: 2px solid $success;\n        }\n        @media (max-width: $mobile) {\n            margin: 2% auto;\n        }\n    }\n\n    .form__field {\n        margin-bottom: 8px;\n        input,\n        select {\n            background-color: #fff;\n            border: 1px solid $rtBlack;\n            color: $rtBlack;\n            width: 100%;\n            padding: 5px;\n        }\n    }\n}\n","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
